module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2QyMTAzNCIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iIzAwN2UzYSIgZD0iTTEyOCAxMjhoMjU2djI1NkgxMjh6Ii8+CiAgPGNpcmNsZSByPSI4NS4zMzMiIGN5PSIyNTYiIGN4PSIyODgiIGZpbGw9IiNmZmYiLz4KICA8ZWxsaXBzZSBjeT0iMjU2IiBjeD0iMzA4LjU2NSIgcng9IjczLjg5OCIgcnk9Ijg1LjMzMyIgZmlsbD0iIzAwN2UzYSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/mv.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/mv.svg
// module chunks = 0